import {AbstractControl, ValidationErrors} from "@angular/forms";

export function containsUppercaseValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || /[A-Z]/.test(control.value)) {
    return null;
  }

  control.setErrors({containsUppercase: true});
  return {containsUppercase: true};
}
